import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Avatar, Chip, Typography, CircularProgress, InputAdornment, TextField, IconButton, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import './checklist.css'
import MyTable from '../../components/Schedule/MyTable';
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
// import EmptyState from '../../components/Error/EmptyState';
import MyChecklistCard from './MyChecklistCard';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';

const MyChecklist = () => {
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState("")
    const [searchResult, setSearchResult] = useState('');
    const [duration, setDuration] = useState('');
    const [checklistType, setChecklistType] = useState('');
    const [viewType, setViewType] = useState("card");
    const [allChecklist, setAllChecklist] = useState([])
    const [checklistDetails, setChecklistDetails] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [listType, setListType] = useState('Upcoming')
    const [pastCount, setPastCount] = useState(0)
    const [upcomingCount, setUpcomingCount] = useState(0)
    const [itemsPerPage, setItemsPerPage] = useState(10)

    const columns = [
        {
            field: 'title', headerName: 'Title', flex: 1, minWidth: 160, valueGetter: (params) => params.row.checklist?.title
        },
        {
            field: 'assigned', headerName: 'Assigned by', flex: 1, minWidth: 180, valueGetter: (params) => params.row.checklist?.employee_full_name
        },
        {
            field: 'created_on', headerName: 'Due Date', flex: 1, minWidth: 200, renderCell: (params) => {
                return (
                    <div className={(params?.row?.status == 'pending' && listType == "Past") && 'red-font'}>
                        {varFormatTime(params.row.checklist_date, user?.Time_Format)}
                    </div>
                );
            }
        },
        {
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 350,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>

						{/* Checklists */}
						<Chip
							variant="outlined"
							sx={{
								backgroundColor: '#EAECF0',
								color: '#2B3F6C',
								border: '1px solid #2B3F6C',
								cursor: 'pointer'
							}}
							avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
							label={'Checklists'}
							onClick={() => {
								setShowModal(true)
								setTitle(params.row?.checklist?.title)
								getChecklistDetails(params?.row?.checklist_id)
							}}
						/>

						{/* Fill */}
						{params?.row?.status == "pending" ?
							<Link style={{ pointerEvents: params.row.is_filled === 0 ? 'none' : 'auto' }} to={`/firehouse/mychecklist-item/${params?.row?.checklist_id}/${params?.row?.id}`}>
								<Chip
									variant="outlined"
									sx={{
										backgroundColor: params.row.is_filled === 0 ? '#D0D5DD' : '#BF1D2D',
										color: '#F5F5F5',
										border: params.row.is_filled === 0 ? ' none' : '1px solid #BF1D2D',
										cursor: 'pointer'
									}}
									avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
									label={'Fill'}
									disabled={params.row.is_filled === 0}
								/>
							</Link>
							:
							params?.row?.status == "completed" ?
								<Link to={`/firehouse/mychecklist-item/${params?.row?.checklist_id}/${params?.row?.id}`}>
									<Chip
										variant="outlined"
										sx={{
											backgroundColor: '#01784F',
											color: '#F5F5F5',
											border: '1px solid #01784F',
											cursor: 'pointer'
										}}
										avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
										label={'Filled'}
									/>
								</Link>

								:
								params?.row?.status == "started" ?
									<Link
										to={{
											pathname: `/firehouse/mychecklist-item/${params?.row?.checklist_id}/${params?.row?.id}`,
										}}
										state={{ title: params?.row?.checklist?.title }}>
										<Chip
											variant="outlined"
											sx={{
												backgroundColor: '#BF1D2D',
												color: '#F5F5F5',
												border: '1px solid #BF1D2D',
												cursor: 'pointer'
											}}
											avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
											label={'Resume Filling'}
										/>
									</Link>
									:
									params?.row?.status == "failed" ?
										<Link to={`/firehouse/mychecklist-item/${params?.row?.checklist_id}/${params?.row?.id}`}>
											<Chip
												variant="outlined"
												sx={{
													backgroundColor: '#2E3238',
													color: '#F5F5F5',
													border: '1px solid #2E3238',
													cursor: 'pointer'
												}}
												avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
												label={'Failed'}
											/>
										</Link>
										:
										<Chip
											variant="outlined"
											sx={{
												backgroundColor: '#BF1D2D',
												color: '#F5F5F5',
												border: '1px solid #BF1D2D',
												cursor: 'pointer'
											}}
											avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
											label={'Error'}
										/>
						}
					</Box>
				);
			},
		}
	]

	const getChecklist = (loader = true) => {
		const body = {
			'limit': itemsPerPage,
			'page': currentPage,
			'search': searchResult,
			'type': listType
		}
		if (loader) {
			setLoading(true)
		}
		ApiService.post('/checklist-user', body)
			.then((data) => {
				setAllChecklist(data?.data)
				setTotalPages(Math.ceil(data?.total / data?.per_page));
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const getChecklistCount = (loader = true) => {
		if (loader) {
			setLoading(true)
		}
		ApiService.get('/checklist-user/count')
			.then(({ data }) => {
				setUpcomingCount(data?.upcoming_count)
				setPastCount(data?.past_count)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const getChecklistDetails = (id) => {
		const body = {
			"checklist_id": id
		}
		ApiService.post('/checklist/details', body)
			.then(({ data }) => {
				setChecklistDetails(data)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const handlePageChange = (_, value) => {
		setCurrentPage(value);
	};

	useEffect(() => {
		getChecklist()
		getChecklistCount()
	}, [listType])

	useEffect(() => {
		getChecklist(false)
	}, [currentPage, searchResult, duration, checklistType])

	return (
		<>
			{loading ? (
				<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
					<CircularProgress />
				</Paper>
			) :
				(
					<>
						<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
							<Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px", marginLeft: "7px" }} >
								{/* Heading */}
								<Grid item xs={10} md={4}>
									<Typography variant="h5">My Checklist</Typography>
								</Grid>

                                {/* Upcoming Chip Button */}
                                <Grid container item md={3} gap={2}>
                                    <Grid item xs={6} sm={6} md={6}>
                                        <div className={listType == 'Upcoming' ? 'tab-active' : 'tab-white'}
                                            onClick={() => {
                                                setListType('Upcoming')
                                                setSearchResult('')
                                            }}>
                                            {`Upcoming (${upcomingCount})`}
                                        </div>
                                    </Grid>

                                    {/* Past Chip Button */}
                                    <Grid item xs={6} sm={6} md={5}>
                                        <div className={listType == 'Past' ? 'tab-active' : 'tab-white'}
                                            onClick={() => {
                                                setListType('Past')
                                                setSearchResult('')
                                            }}>
                                            {`Past (${pastCount})`}
                                        </div>
                                    </Grid>
                                </Grid>

                                {/* List & Grid Icon */}
                                <Grid item xs={6} sm={6} md={1}>
                                    <div
                                        style={{
                                            height: "48px",
                                            border: "1px solid #EAECF0",
                                            borderRadius: "8px",
                                            marginLeft: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "48px",
                                                height: "48px",
                                                borderRight: "1px solid #EAECF0",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setViewType("card")}
                                        >
                                            <img
                                                src={viewType === "list" ? "/images/card-empty.svg" : "/images/card.svg"}
                                                height="22px"
                                                width="22px"
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "48px",
                                                height: "48px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setViewType("list")}
                                        >
                                            <img
                                                src={viewType === "list" ? "/images/listview.svg" : "/images/list-empty.svg"}
                                                height="20px"
                                                width="20px"
                                            />
                                        </div>
                                    </div>
                                </Grid>

								{/* Search field */}
								<Grid item xs={12} sm={12} md={3}>
									<TextField
										variant="outlined"
										placeholder="Search"
										onChange={(e) => setSearchResult(e.target.value)}
										className="w-100"
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton>
														<SearchIcon />
													</IconButton>
												</InputAdornment>
											),
											sx: {
												height: '48px',
												fontSize: '14px',
												marginRight: '10px',
											},
										}}
									/>
								</Grid>

							</Grid>

							{(!allChecklist || allChecklist.length == 0) ?
								<Box>
									{searchResult != '' ?
										<div className='mt-2 mx-2' style={{ color: '#555555' }}>
											No Search Results found.
										</div>
										:
										<div className='mt-2 mx-2' style={{ color: '#555555' }}>
											No Checklist available right now.
										</div>}

									<div className='inner-box d-flex align-items-center' style={{ height: 550 }}>
										<img src='/images/blur-logo.png' />
									</div>
								</Box>
								:
								<>
									{viewType == "list" ?
										<div className='mt-4'>
											<MyTable
												rows={allChecklist}
												columns={columns}
												rowCount={allChecklist.length}
												checkboxSelection={false}
												hideFooter={true}
											/>
										</div>
										:
										<>
											<Grid container style={{ marginTop: '3rem' }}>
												{allChecklist.map((item) => (
													<MyChecklistCard item={item} setTitle={setTitle} getChecklistDetails={getChecklistDetails} setShowModal={setShowModal} listType={listType} />
												))}
											</Grid>
										</>
									}
									<Pagination
										count={totalPages}
										page={currentPage}
										onChange={handlePageChange}
										color="primary"
										className="mt-4 d-flex"
										style={{ justifyContent: 'end' }}
									/>
								</>
							}
						</Paper >
					</>
				)
			}

			{/* Checklist Pop-Up View */}
			<div className='font-fam'>
				<Modal show={showModal} size="lg" onHide={() => {
					setShowModal(false)
					setChecklistDetails([])
				}}>

					<Modal.Header closeButton>
						<Modal.Title>Checklist Details - {title}</Modal.Title>
					</Modal.Header>

					<Modal.Body style={{ padding: 30 }}>
						<Grid item xs={12} sm={6} md={6}>

							<div className='font-fam model-bg'>
								{checklistDetails && checklistDetails.map((item) => (
									<div className='row' style={{ marginTop: '6px', marginBottom: '6px' }}>
										<div className='col-md-1'>
											{item?.location?.type == 'location' ?
												<img src='/images/Building.png' style={{ width: 30, height: 30 }} />
												: item?.location?.type == 'location_item' ?
													<img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
													:
													<img src="/images/location-blue.svg" style={{ width: 25, height: 25 }} />
											}
										</div>

										<div className="col-md-6">
											<span style={{ color: !item.description ? '#ccc' : 'inherit', pointerEvents: !item.description ? 'none' : 'auto' , marginLeft:'-24px' }}>
												{item.description || "--"}
											</span>
										</div>

										<div className='font-fam col-md-5'>
											<span style={{ color: '#6E7C87' }}>{item?.location?.type == 'location' ? 'Location' : item?.location?.type	 == 'location_item' ? 'Location & Item' : "Item"}</span> : {(() => {
											const desc = item?.item_location?.item?.item_description || item?.location?.location_description;
												return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
											})()}
										</div>
									</div>
								))}
							</div>

						</Grid>
					</Modal.Body>
				</Modal>
			</div>
		</>
	)
}

export default MyChecklist